import FormControlLabel from '@mui/material/FormControlLabel';
import { alpha, styled } from '@mui/material/styles';

export const StyledCheckboxLabel = styled(FormControlLabel, {
  shouldForwardProp: prop => prop !== 'hasError',
})<{ hasError?: boolean }>(({ hasError = false, theme }) => ({
  marginLeft: 0,
  marginRight: 0,
  alignItems: 'center',
  columnGap: theme.spacing(0.5),
  cursor: 'pointer',
  minHeight: 32,
  '& .MuiCheckbox-root': {
    borderRadius: theme.shape.borderRadius,
    color: hasError ? theme.palette.error.main : undefined,
    padding: theme.spacing(0.5),
    transition: theme.transitions.create(['background-color', 'transform', 'color'], {
      duration: theme.transitions.duration.shorter,
      easing: theme.transitions.easing.easeOut,
    }),
  },
  '& .MuiCheckbox-root.Mui-checked': {
    color: hasError ? theme.palette.error.main : undefined,
  },
  '&:hover .MuiCheckbox-root': {
    backgroundColor: hasError
      ? alpha(theme.palette.error.main, theme.palette.action.hoverOpacity)
      : theme.palette.action.hover,
  },
  '&:hover .MuiCheckbox-root.Mui-checked': {
    backgroundColor: alpha(
      hasError ? theme.palette.error.main : theme.palette.primary.main,
      theme.palette.action.hoverOpacity
    ),
  },
  '& .MuiCheckbox-root .MuiSvgIcon-root': {
    transition: theme.transitions.create(['transform', 'filter'], {
      duration: theme.transitions.duration.shorter,
      easing: theme.transitions.easing.easeOut,
    }),
  },
  '& .MuiCheckbox-root.Mui-checked .MuiSvgIcon-root': {
    filter: `drop-shadow(0 1px 2px ${alpha(hasError ? theme.palette.error.main : theme.palette.primary.main, 0.35)})`,
    transform: 'scale(1.06)',
  },
  '&:active .MuiCheckbox-root .MuiSvgIcon-root': {
    transform: 'scale(0.96)',
  },
  '& .MuiFormControlLabel-label': {
    fontSize: 16,
    lineHeight: 1.35,
  },
}));
